import { render, staticRenderFns } from "./BaseAddressCope.vue?vue&type=template&id=2950d690&scoped=true"
import script from "./BaseAddressCope.vue?vue&type=script&lang=js"
export * from "./BaseAddressCope.vue?vue&type=script&lang=js"
import style0 from "./BaseAddressCope.vue?vue&type=style&index=0&id=2950d690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950d690",
  null
  
)

export default component.exports